import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_ctx.isSvg)
    ? (_openBlock(), _createBlock(_component_inline_svg, {
        key: 0,
        src: _ctx.getSrc(),
        width: _ctx.width,
        height: _ctx.height
      }, null, 8, ["src", "width", "height"]))
    : (_openBlock(), _createBlock(_component_fa_icon, {
        key: 1,
        icon: _ctx.icon
      }, null, 8, ["icon"]))
}